import { render } from "./ModalProjectDelete.vue?vue&type=template&id=a9cffe28&scoped=true&ts=true"
import script from "./ModalProjectDelete.vue?vue&type=script&lang=ts"
export * from "./ModalProjectDelete.vue?vue&type=script&lang=ts"

import "./ModalProjectDelete.vue?vue&type=style&index=0&id=a9cffe28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9cffe28"]])

export default __exports__